import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DatePicker } from 'components';
import { makeStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { Grid, Button, Autocomplete, TextField, createFilterOptions } from '@mui/material';
import moment from 'moment';
import validate from 'validate.js';
import _ from 'underscore';

import { SetFormState, GetCositeHealthCheck } from '../../actions/CositeHealthCheckActions.js';

const schema = {
	siteId: {
		presence: { allowEmpty: false, message: 'is required' },
	}
};

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const CositeHealthCheckForm = (props) => {
	const { sites, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.cositeHealthCheckReducer.formState);

	const filterOptions = createFilterOptions({
		limit: 50
	});

	const _hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));

	const _handleChange = (name, value) => {
		setFormState({
			...formState,
			values: {
				...formState.values,
				[name]: value
			},
			touched: {
				...formState.touched,
				[name]: true,
			},
		});
	};

	useMemo(() => {
		const newTouched = {};

		if (formState.submit) {
			_.each(_.keys(schema), item => {
				newTouched[item] = true;
			});
		}
		const errors = validate(formState.values, schema, {
			fullMessages: false
		});

		setFormState({
			...formState,
			isValid: !errors,
			errors: errors || {},
			touched: {
				...formState.touched,
				...newTouched
			}
		});
	}, [formState.values, formState.submit]);

	const _onClickCheckCositeHealth = () => {
		setFormState({ ...formState, submit: true });
		if (formState.isValid) {
			dispatch(GetCositeHealthCheck(formState.values.siteId.value));
		}
	};

	return (
		<div className={classes.fields}>
			<Grid container spacing={2}>
				<Grid item md={4} xs={4}>
					<Autocomplete
						id="siteId"
						name="siteId"
						hintText="Site Id"
						options={sites || []}
						value={formState.values.siteId || { value: '', text: '' }}
						getOptionLabel={(option) => `${option.text}`}
						renderInput={(params) => <TextField {...params} label="Site Id" variant="outlined" />}
						filterOptions={filterOptions}
						onChange={(event, value) => { _handleChange('siteId', value); }}
						error={_hasError('siteId')}
						helperText={
							_hasError('siteId')
								? formState.errors.siteId[0]
								: null
						}
					/>
				</Grid>
				<Grid item lg={4} xs={4}>
					<Button
						className={classes.agreeButton}
						color="primary"
						variant="contained"
						size="large"
						onClick={_onClickCheckCositeHealth}
					>
						Check Cosite Health
					</Button>
				</Grid>
			</Grid>
		</div>
	);
};

CositeHealthCheckForm.propTypes = {
	sites: PropTypes.array.isRequired
};

export default CositeHealthCheckForm;
